import { http } from 'vue'

export default {
  // load accounts from the API server
  loadAccounts (context, params = {}) {
    return http.get('accounts?company_id=' + params.companyId)
  },
  // create account at the API server
  postAccount (context, params = {}) {
    return http.post('accounts', params.data)
  },
  // edit account at the API server
  putAccount (context, params = {}) {
    return http.put('accounts/' + params.id, params.data)
  },
  // delete account at the API server
  deleteAccount (context, params = {}) {
    return http.delete('accounts/' + params.id)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts/actions.js